import React, {Component} from 'react';
import {connect} from "react-redux";
import FJBGColorContainer from '../view/FJBGColorContainer';
import FJToolbarCommon from '../view/FJToolbarCommon';
import classNames from "classnames";
import FJConfig from "../../../config/FJConfig";
import {FJDocumentColorAction, FJToolbarAction} from "../../../redux/action/FJRoot.action";

class FJToolbarBackgroundColorContainer extends Component {
  render() {
    let {
      disabled,
      documentColors,
      backgroundColor,
      addDocumentColor,
      deleteColor,
      backgroundColorChange,
      active,
    } = this.props;
    let containerClass = classNames('c-toolbar-video', {active});
    return (
      <FJToolbarCommon className={containerClass}>
        <FJBGColorContainer solidColors={FJConfig.solidColors}
                            documentColors={documentColors.solidColors}
                            color={backgroundColor}
                            disabled={disabled}
                            addDocumentColor={addDocumentColor}
                            deleteColor={deleteColor}
                            colorDataChange={backgroundColorChange}/>
      </FJToolbarCommon>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    backgroundColor: state.toolbarBackgroundColor.backgroundColor,
    documentColors: state.documentColor.documentColors,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    backgroundColorChange: function (type, color) {
      dispatch(FJToolbarAction.setBackgroundColorAction(type, color));
    },
    addDocumentColor: function (type, color) {
      dispatch(FJDocumentColorAction.addDocumentColorAction(type, color));
    },
    deleteColor: function (type, index) {
      dispatch(FJDocumentColorAction.deleteDocumentColorAction(type, index));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJToolbarBackgroundColorContainer);
